import {
	Container,
	ContainerGutter,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import * as Icons from '@volkswagen-onehub/icons-core';
import React from 'react';
import { CarlineWithOfertas } from '../../../services/ofertas-service/models/ofertas';
import {
	AnimationContainer,
	FadeContainer,
	Model,
	ModelListContainer,
	ModelsList,
	RelativeContainer,
	TrackingContainer,
} from './ui/model-list-styles';

export const ModelListDesktop = ({
	hasOneCarline,
	carlines,
	activeCarlineIndex,
	handleTrackingOnClick,
}: {
	hasOneCarline: boolean;
	carlines: CarlineWithOfertas[];
	activeCarlineIndex: number;
	handleTrackingOnClick: (carline: CarlineWithOfertas, index: number) => void;
}) => {
	return (
		<ModelListContainer
			className="ofertas__model-list-container main-container"
			id="main-container"
		>
			<RelativeContainer
				className="ofertas__relative-container"
				id="relative-container"
			>
				{!hasOneCarline && (
					<FadeContainer
						className="ofertas__fade-container"
						id="fade-container"
						numberOfModels={carlines.length}
					>
						<ModelsList
							className="ofertas__models-list scroll-container"
							id="scroll-container"
						>
							{carlines.map((carline, index) => {
								const isActive = activeCarlineIndex === index;

								return (
									<Model
										key={index}
										className={`ofertas__model-${carline.name}`}
										id={`model-${index}`}
									>
										<TrackingContainer
											className="ofertas__tracking-div"
											onClick={() => handleTrackingOnClick(carline, index)}
										>
											<Container
												wrap={'never'}
												gutter={ContainerGutter.static100}
												verticalAlign={'center'}
											>
												{isActive && (
													<Text>
														<AnimationContainer isActive={isActive}>
															<Icons.ArrowRight variant="small" />
														</AnimationContainer>
													</Text>
												)}

												<Text
													appearance={TokenTextAppearance.headline200}
													color={
														isActive
															? TokenTextColor.primary
															: TokenTextColor.secondary
													}
													bold
												>
													<AnimationContainer isActive={isActive}>
														{carline.nuevo ? 'NUEVO ' : ''}
														{carline.title.toLocaleUpperCase()}
													</AnimationContainer>
												</Text>
											</Container>
										</TrackingContainer>
									</Model>
								);
							})}
						</ModelsList>
					</FadeContainer>
				)}
			</RelativeContainer>
		</ModelListContainer>
	);
};
